module.exports = __webpack_public_path__ + "static/media/Sakura-Alt-Regular.f6224afc.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/Sakura-Alt-Regular.woff
 ** module id = 1889
 ** module chunks = 50
 **/